export default {
  type: 'fyUserMetricsDecisions',
  name: 'Approved / Excluded Projects',
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_fy_users' },
    update: { app: 'metrics_dash', role: 'metrics_fy_users' },
    delete: { app: 'metrics_dash', role: 'metrics_fy_users' }
  },
  newButton: false,
  search: {
    search: 'allFyUserMetricsDecisions',
    orderBy: {
      type: 'FyUserMetricsDecisionsOrderBy',
      default: 'PROJECT_TITLE_ASC'
    },
    fields: [
      {
        name: 'fy',
        label: 'Fiscal Year',
        type: 'number',
        fieldType: 'Int',
        default: '$store.state.currentFiscalYear',
        min: 2016,
        order: 'FY'
      },
      {
        name: 'personId',
        label: 'Person',
        order: 'PERSON_ID',
        searchable: false
      },
      {
        name: 'projectTitle',
        order: 'PROJECT_TITLE',
        searchable: false
      },
      {
        name: 'decision',
        type: 'select',
        fieldType: 'String',
        options: [
          { value: null, text: 'All' },
          { value: 'approve', text: 'Approved' },
          { value: 'exclude', text: 'Excluded' }
        ]
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'fy',
        type: 'Int',
        required: true
      },
      {
        field: 'personId',
        type: 'Int',
        required: true
      },
      {
        field: 'projectTitle',
        required: true
      },
      {
        field: 'decision',
        required: true
      }
    ],
    key: ['fy', 'personId', 'projectTitle'],
    input: 'fyUserMetricsDecision',
    create: 'createFyUserMetricsDecision',
    delete: 'deleteFyUserMetricsDecision',
    update: 'updateFyUserMetricsDecision'
  },
  load: {
    nodeId: 'fyUserMetricsDecision',
    key: 'fyUserMetricsDecisionByFyAndPersonIdAndProjectTitle'
  },
  form: {
    print: false,
    schema: [
      [
        {
          name: 'fy',
          label: 'Fiscal Year',
          type: 'number',
          readonly: true,
          width: 2,
          required: true
        },
        {
          name: 'projectTitle',
          required: true,
          readonly: true,
          width: 8
        },
        {
          name: 'decision',
          type: 'select',
          options: [
            { value: 'approve', text: 'Approved' },
            { value: 'exclude', text: 'Excluded' }
          ],
          width: 2,
          required: true
        }
      ],
      {
        name: 'personId',
        type: 'link',
        label: 'Person',
        search: {
          field: 'personId',
          lookup: 'allPeople',
          filters: {
            statusCode: {
              in: {
                default: '["A", "F"]'
              }
            }
          },
          fieldWidth: 3,
          additionalFields: [
            {
              name: 'fullName',
              label: 'Name',
              width: 4
            },
            {
              name: 'email',
              width: 5
            },
            {
              name: 'affiliation',
              width: 9
            },
            {
              name: 'phone',
              width: 3
            },
            {
              name: 'address1',
              width: 3
            },
            {
              name: 'address2',
              width: 3
            },
            {
              name: 'city',
              width: 2
            },
            {
              name: 'state',
              width: 1
            },
            {
              name: 'countryCode',
              label: 'Country',
              width: 1
            },
            {
              name: 'zipCode',
              width: 2
            }
          ]
        },
        readonly: true,
        required: true
      }
    ]
  }
}
